import { useSyncExternalStore } from 'react';
export default function useBinding(binding) {
  const state = useSyncExternalStore(subscribe => {
    binding.subscribe(subscribe);
    return () => binding.unsubscribe(subscribe);
  }, binding.get);
  return [state, binding.set];
}